class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');

    new IntersectionObserver(
      this.handleIntersection.bind(this)
    ).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        const miniCart = document.getElementById('mini-cart');

        if (!miniCart) return;

        miniCart.innerHTML = this.getSectionInnerHTML(
          html,
          '.shopify-section'
        );

        /*
         * Cart drawer has been loaded.
         * Give the gift app time to detect the new
         * AHL gift wrapper containers.
         */
        setTimeout(() => {
          this.initializeGiftOffers();
        }, 100);

        document.dispatchEvent(
          new CustomEvent('cartdrawer:opened')
        );
      })
      .catch(e => {
        console.error('Mini Cart Error:', e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');

    if (detailsElement.hasAttribute('open')) {
      return;
    }

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);

      if (!element) return;

      element.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    /*
     * Cart contents have changed.
     * Re-initialize gift offer containers.
     */
    setTimeout(() => {
      this.initializeGiftOffers();
    }, 100);

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    const parsedHTML = new DOMParser()
      .parseFromString(html, 'text/html');

    const section = parsedHTML.querySelector(selector);

    return section ? section.innerHTML : '';
  }

  /*
   * ============================================
   * OCTOBER GIFT OFFERS
   * ============================================
   *
   * Offer 1:
   * ₹1,499+ + 2 products
   * FREE Mini Bag Charm
   *
   * AHL Wrapper:
   * ahl_gift_wrapper_245142
   *
   *
   * Offer 2:
   * ₹2,499+ + 2 products
   * 10% OFF + FREE Mini Bag
   *
   * AHL Wrapper:
   * ahl_gift_wrapper_991428
   *
   * ============================================
   */

  initializeGiftOffers() {
    const offerOne = document.getElementById(
      'ahl_gift_wrapper_245142'
    );

    const offerTwo = document.getElementById(
      'ahl_gift_wrapper_991428'
    );

    /*
     * If the wrappers don't exist,
     * there is nothing to initialize.
     */
    if (!offerOne && !offerTwo) {
      return;
    }

    /*
     * Tell the page that the cart gift
     * containers are ready.
     */
    document.dispatchEvent(
      new CustomEvent('ahl:gift-wrappers-ready', {
        detail: {
          offerOne: !!offerOne,
          offerTwo: !!offerTwo
        }
      })
    );

    /*
     * Dispatch common events that gift/upsell
     * apps can listen for after cart updates.
     */
    document.dispatchEvent(
      new CustomEvent('cart:updated')
    );

    document.dispatchEvent(
      new CustomEvent('cart:refresh')
    );

    /*
     * Trigger a resize event.
     * Some widgets detect their containers
     * after resize/layout changes.
     */
    window.dispatchEvent(
      new Event('resize')
    );
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);